import { useId } from 'react'
import {
  Mtds,
  matrixAmountUnitLabels,
  type MatrixAmountUnit
} from 'prove-common'
import type { MatrixAmountDraft } from '../../utils/matrixAmount'

type MatrixAmountFieldsProps = {
  draft: MatrixAmountDraft
  error?: string
  disabled?: boolean
  required?: boolean
  onChange: (draft: MatrixAmountDraft) => void
  onEnter?: () => void
}

export const MatrixAmountFields = ({
  draft,
  error,
  disabled,
  required = false,
  onChange,
  onEnter
}: MatrixAmountFieldsProps) => {
  const id = useId()
  const unitOptions = (
    Object.entries(matrixAmountUnitLabels) as [MatrixAmountUnit, string][]
  ).map(([value, label]) => ({ value, label }))
  return (
    <Mtds.Field>
      <label id={`${id}_label`} htmlFor={id}>
        Mengde prøvemateriale
      </label>
      <div className='flex flex-row gap-2 break-normal'>
        <Mtds.Input
          id={id}
          aria-labelledby={`${id}_label`}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? `${id}_error` : undefined}
          className='flex-1'
          type='number'
          min='0'
          step='0.01'
          value={draft.value}
          disabled={disabled}
          required={required}
          onChange={({ target }) => onChange({ ...draft, value: target.value })}
          onKeyDown={(event) => {
            if (event.key === 'Enter') onEnter?.()
          }}
        />
        <Mtds.Field
          as='select'
          aria-label='Enhet'
          className='flex-1'
          value={draft.unit}
          disabled={disabled}
          required={required}
          onChange={({ target }) =>
            onChange({ ...draft, unit: target.value as MatrixAmountUnit | '' })
          }
          options={[{ value: '', label: 'Velg enhet' }, ...unitOptions]}
        />
      </div>
      {error && <Mtds.Validation id={`${id}_error`}>{error}</Mtds.Validation>}
    </Mtds.Field>
  )
}
